import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  generateRecaptchaToken
} from "./chunk-W4XMZLKW.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/contact/contactUs.ts
import { generateMd5 } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var contactUs = (body) => __async(void 0, null, function* () {
  var _a;
  try {
    const signature = generateMd5(body.phone);
    const captcha = yield generateRecaptchaToken("contact");
    const data = yield fetchClient({
      url: "/contact-us",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, body), {
          captcha,
          signature
        }))
      }
    });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const msg = Object.values((data == null ? void 0 : data.error) || {})[0] || (data == null ? void 0 : data.error);
      throw new Error(String(msg));
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "contactUsException"
    });
  }
});

export {
  contactUs
};
//# sourceMappingURL=chunk-YROKKDJX.mjs.map